import React from "react"
import SupporterSummary from "./supporterSummary"
import SupportedByStyles from "./supportedBy.styles";
import Typography from '@material-ui/core/Typography';

const supportersLayout = [2, 1, 1, 1, 2];

const mapSupporters = (supporters) => {
    var current = 0;
    const mappedSupporters = [];

    supportersLayout.forEach((value, index) => {
        mappedSupporters[index] = [];
        for (let i = 0; i < value; i++) {
            mappedSupporters[index].push(supporters[current]);
            current += 1;
        };
    });
    if (current !== supporters.length)
        console.warn("Number of supporters does not match supporter layout");

    return mappedSupporters;
}

export const SupportedBy = ({ supporters }) => {
    const classes = SupportedByStyles();

    const mappedSupporters = mapSupporters(supporters);

    return (
        <div className={classes.mainSupportedByStyles}>
            <Typography variant="h5" className={classes.supportedByTitle}>Supported By</Typography>

            <div className={classes.supportersContainer}>
                {mappedSupporters.map((column, index) => (
                    <div className={classes.supporterColumn} key={index}>
                        {column.map(supporter => {
                            if (supporter)
                                return <SupporterSummary key={supporter.id} supporter={supporter} />;
                        })}
                    </div>
                ))}
            </div>
        </div>
    );
}

SupportedBy.NAME = "SupportedBy";
export default SupportedBy
